import type { HTTPService } from "@soft-db/http";

export type Distributor = {
	id: string;
	name: string;
	timezone: string;
	imageUrl: string;
	preventDelete: boolean;
	archived: boolean;
	isHost: boolean;
};

export type UpdateDistributor = {
	name: string;
	timezone: string;
};

export type CreateDistributor = {
	name: string;
};

// TODO: Update api calls when backend changes
export class DistributorApi {
	constructor(private _http: HTTPService) {}

	async fetchAll() {
		return await this._http.get<Distributor[]>(`distributors`);
	}

	async fetch(id: string) {
		return await this._http.get<Distributor>(`distributors/${id}`);
	}

	async create(name: string) {
		return await this._http.post<Distributor>(`distributors`, { name });
	}

	async update(id: string, difference: UpdateDistributor) {
		return await this._http.put<Distributor>(`distributors/${id}`, difference);
	}

	async updateLogo(id: string, image: File) {
		return await this._http.postFile<Distributor>(`distributors/${id}/logo`, "file", image);
	}

	async deleteLogo(id: string) {
		return await this._http.delete<Distributor>(`distributors/${id}/logo`);
	}

	async delete(id: string) {
		return await this._http.delete(`distributors/${id}`);
	}
}
